// src/themes/darkTheme.js
import { defaultTheme } from "react-admin";
import { deepmerge } from "@mui/utils";

const DarkTheme = deepmerge(defaultTheme, {
  palette: {
    mode: "dark",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          "[data-mui-color-scheme='dark'] .react-json-view .string-value": {
            color: "#ff4d4f !important",
          },
          "#main-content > div > div > div > div > div > table > thead > tr > th > span":
            {
              color: "white",
            },
          ".RaList-main a:active": {
            color: "white",
          },
          "#root > div > div > main > div.MuiDrawer-root.MuiDrawer-anchorLeft.MuiDrawer-docked.RaSidebar-docked.RaSidebar-open > div > div > ul > a.MuiButtonBase-root.MuiMenuItem-root.MuiMenuItem-gutters.MuiMenuItem-root.MuiMenuItem-gutters.RaMenuItemLink-active":
            {
              backgroundImage:
                "linear-gradient(90deg, rgba(232, 203, 192, 0.872) 0%, rgba(99, 111, 164, 0.794) 100%)",
            },
          // ".react-json-view span": {
          //   color: "#C2B9C7 !important",
          // },
          ".RaSidebar-fixed": {
            backgroundImage:
              "radial-gradient(circle,rgba(94, 87, 97, 1) 0%, rgba(38, 35, 64, 1) 100%)",
          },
          "#main-content > div > div > div > div > div > table > tbody > tr > td > a":
            {
              color: "white",
            },
          "#main-content > div > div.MuiToolbar-root.MuiToolbar-regular > a.MuiButtonBase-root.MuiIconButton-root.MuiIconButton-colorPrimary.MuiIconButton-sizeLarge.RaEditButton-root":
            {
              color: "white",
            },
          "#main-content a": {
            color: "white",
          },
          "#main-content > div > div > div.RaList-actions > div > button": {
            color: "white",
          },
          "#main-content > div > div.RaShow-main > div > div > div.RaTabbedShowLayout-content > div > span > div > div > div > div > span":
            {
              color: "white",
            },
          "#main-content > div > div > div.RaList-actions > form > div > div.MuiFormGroup-root.ra-input.ra-input-has_changes > label > span.MuiTypography-root.MuiFormControlLabel-label":
            {
              color: "gray",
            },
          "#main-content > div > div > div.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiCard-root.RaList-content > div > div > div > div.MuiToolbar-root.MuiToolbar-dense.RaBulkActionsToolbar-topToolbar > button":
            {
              color: "white",
            },
          "#main-content > div > div.RaShow-main > div > div > div.RaTabbedShowLayout-content > div > span > div > div > div.RaList-actions > div > div > span":
            {
              color: "white",
            },

          "#main-content > div > div > h5": {
            color: "white",
          },
          "#main-content > div > div > form > fieldset": {
            color: "white",
          },
          // "#main-content > div > div": {
          //   background:
          //     "radial-gradient(circle,rgba(94, 87, 97, 1) 0%, rgba(38, 35, 64, 1) 100%)",
          // },

          "#main-content > div > div > form > div.MuiFormControl-root.MuiFormControl-marginNormal.MuiFormControl-fullWidth.MuiTextField-root > div":
            {
              background: "none",
              color: "white",
            },
          "#:rb:-label": {
            color: "white",
          },
          "#main-content > div > div > div.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiCard-root.RaList-content > div > div.RaDatagrid-tableWrapper > table > tbody > tr > td.MuiTableCell-root.MuiTableCell-body.column-tag_ids.RaDatagrid-rowCell > span > span > div > a > div":
            {
              color: "white",
            },
          "#main-content > div > div > div.RaList-actions > div > div > span": {
            color: "white",
          },
          "#main-content > div > div > div > div > span ": {
            color: "white",
          },
          "#main-content > div > div.RaShow-main > div > div > div.RaTabbedShowLayout-content > div > span > div > div > div.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1.MuiCard-root.RaList-content > div > div > div > div.MuiToolbar-root.MuiToolbar-dense.RaBulkActionsToolbar-topToolbar > button":
            {
              color: "white",
            },
          ".config-json .react-json-view .string-value": {
            color: "#7367F0",
          },
          "#main-content > div > div.RaEdit-main > div > form > div.MuiCardContent-root > div > div > span > div ":
            {
              fontFamily: "monospace",
              cursor: "default",
              background: "linear-gradient(to right, #928dab)",
              color: "#fff",
              padding: "1rem",
              borderRadius: "10px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
              transition: "all 0.3s ease",
              margin: "1rem 0",
            },
          // "#main-content > div > div.RaShow-main > div > div > div > span.MuiStack-root.ra-field.ra-field-config.RaSimpleShowLayout-row > div > div > div > div > div > div > div ":
          //   {
          //     fontFamily: "monospace",
          //     cursor: "default",
          //     background: "linear-gradient(to right, #928dab)",
          //     color: "#fff",
          //     padding: "1rem",
          //     borderRadius: "10px",
          //     boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
          //     transition: "all 0.3s ease",
          //     margin: "1rem 0",
          //   },
          "#main-content > div > div.RaShow-main > div > div > div > span.MuiStack-root.ra-field.ra-field-config.RaSimpleShowLayout-row > div ":
            {
              fontFamily: "monospace",
              cursor: "default",
              background: "linear-gradient(to right, #928dab)",
              color: "#fff",
              padding: "1rem",
              borderRadius: "10px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
              transition: "all 0.3s ease",
              margin: "1rem 0",
              width: "20%",
              "@media (max-width:1150px)": {
                width: "100%",
              },
            },
          "#main-content > div > div > div > form > div.MuiCardContent-root > div > div > span > div":
            {
              fontFamily: "monospace",
              cursor: "default",
              background: "linear-gradient(to right, #928dab)",
              color: "#fff",
              padding: "1rem",
              borderRadius: "10px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
              transition: "all 0.3s ease",
              margin: "1rem 0",
            },

          "#main-content > div > div.RaShow-main > div > div > div > span.MuiStack-root.ra-field.ra-field-transactions.RaSimpleShowLayout-row > div":
            {
              fontFamily: "monospace",
              cursor: "default",
              background: "linear-gradient(to right, #928dab)",
              color: "#fff",
              padding: "1rem",
              borderRadius: "10px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
              transition: "all 0.3s ease",
              margin: "1rem 0",

              width: "20%",
              "@media (max-width:1150px)": {
                width: "100%",
              },
            },
          "#main-content > div > div.RaShow-main > div > div > div > span.MuiStack-root.ra-field.ra-field-payload.RaSimpleShowLayout-row > div":
            {
              fontFamily: "monospace",
              cursor: "default",
              background: "linear-gradient(to right, #928dab)",
              color: "#fff",
              padding: "1rem",
              borderRadius: "10px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
              transition: "all 0.3s ease",
              margin: "1rem 0",
              width: "20%",
              "@media (max-width:1150px)": {
                width: "100%",
              },
            },
          ".RaChipField-chip": {
            color: "#4B0082",
          },
          "#main-content > div > div > div.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiCard-root.RaList-content > div > div > table > tbody > tr > td.MuiTableCell-root.MuiTableCell-body.MuiTableCell-sizeSmall.column-merchant_payment_gateway_id.RaDatagrid-rowCell > span > a > span":
            {
              color: "#F0F8FF",
            },
          "#main-content > div > div > div.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1.MuiCard-root.RaList-content > div > div > table > tbody > tr > td.MuiTableCell-root.MuiTableCell-body.MuiTableCell-sizeSmall.column-client_id.RaDatagrid-rowCell > span > a > span":
            {
              color: "#F0F8FF",
            },
          ".custom-link": {
            textDecoration: "underline",
            transition: "color 0.2s",
          },

          ".custom-link.dark": {
            color: "#F0F8FF",
          },

          ".custom-link:hover": {
            color: "#F0F8FF",
            textDecoration: "none",
          },
          "#main-content > div > div > div.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1.MuiCard-root.RaList-content > div > div > table > tbody > tr > td.MuiTableCell-root.MuiTableCell-body.MuiTableCell-sizeSmall.column-trunc_id.RaDatagrid-rowCell > span > a > span":
            {
              color: "#F0F8FF",
            },
          "#main-content > div > div > div.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1.MuiCard-root.RaList-content.css-1j74uew-MuiPaper-root-MuiCard-root > div > div > table > tbody > tr > td.MuiTableCell-root.MuiTableCell-body.MuiTableCell-sizeSmall.column-session_id.RaDatagrid-rowCell.css-jiabcu-MuiTableCell-root > span":
            {
              color: "#E6E6FA",
            },
        },
      },
    },
  },
});

export default DarkTheme;
